<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest} width={73} height={17} viewBox="0 0 73 17">
	<path
		d="M34.1787 3.07269V0.0558735H24.3966V16.0557H34.2933V13.0384H27.5504V9.44977H33.6077V6.47846H27.5504V3.07269H34.1787Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M3.15419 6.40998V0.0556641H0V16.0555H3.15419V9.42722H9.0968V16.0555H12.2282V0.0556641H9.0968V6.40998H3.15419Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M54.8831 9.81576L48.0261 0.0556641H45.6262V16.0555H48.7804V6.27303L55.6374 16.0555H58.0373V0.0556641H54.8831V9.81576Z"
		fill={getTailwindColor(color)}
	/>
	<path d="M73.219 16.0555V0.0556641H70.0652V16.0555H73.219Z" fill={getTailwindColor(color)} />
</SvgWrapper>
